import { memo } from 'react';
import { componentWithCondition } from '../component-with-condition/index.tsx';

/**
 * A utility function that conditionally applies React.memo on a component based on a provided condition.
 * Useful for if you want to memoize a component that uses a relay fragment, so that you don't need
 * to rename the component and cause relay/linting to change the fragment names.
 */
export const memoWithCondition = (condition: () => boolean, ...args: Parameters<typeof memo>) => {
	return componentWithCondition(condition, memo(...args), args[0]);
};
